import styled, { css } from 'styled-components';
import { Color } from '../../base';

const AnchorWrapper = styled.a`
  ${props =>
    props.type === 'button' &&
    css`
    padding: 10px 30px;
    background-color: ${Color.red};
    color: ${Color.white} !important;
    border-radius: 4px;
    font-weight: 600;
    display: inline-block;
    text-align: center;
    
    ${props.color === 'white' &&
      css`
        background-color: ${Color.white};
        color: ${Color.red} !important;
      `}

    ${props.outline &&
      css`
        background-color: transparent;
        color: ${Color.red} !important;
        border: 1px solid ${Color.red};
      `}

    ${props.circle &&
      css`
        border-radius: 100px;
      `}

    ${props.size === 'large' &&
      css`
        padding: 20px 30px;
      `}

    ${props.block &&
      css`
        width: 100%;
      `}
  `}
`;

export { AnchorWrapper };
